import { http } from '../http';
import { extrairMensagemErro } from '../../utils/apiError';

export interface RateioResponse {
  valorRateio: number;
  cota: number;
  valorPorCota?: number;
  competencia?: string;
  defasado?: boolean;
}

export interface ValorCotaStatus {
  competenciaCorrente: string;
  temValorNoMes: boolean;
  defasado: boolean;
  valorEmUso: number;
  competenciaDoValor: string;
  origem: 'MANUAL' | 'AUTOMATICO' | null;
  atualizadoEm: string | null;
  atualizadoPor: string | null;
}

export interface ValorCotaHistoricoItem {
  competencia: string;
  valor: number;
  origem: 'MANUAL' | 'AUTOMATICO';
  atualizadoEm: string;
  atualizadoPor: string | null;
}

export const calcularRateio = async (
  codigo_regional: string,
  codigo_tipo_veiculo: string,
  valor_fipe: number,
  codigo_cota?: string
): Promise<RateioResponse> => {
  const payload = {
    codigo_regional,
    codigo_tipo_veiculo,
    valor_fipe,
    ...(codigo_cota ? { codigo_cota } : {}),
  };

  try {
    const response = await http.post('/rateio/calcular', payload);
    return response.data;
  } catch (error) {
    throw new Error(extrairMensagemErro(error, 'Erro ao calcular rateio'));
  }
};

export const getValorCotaStatus = async (): Promise<ValorCotaStatus> => {
  try {
    const response = await http.get('/rateio/valor-cota/status');
    return response.data;
  } catch (error) {
    throw new Error(extrairMensagemErro(error, 'Erro ao consultar status do rateio por cota'));
  }
};

export const getValorCotaHistorico = async (): Promise<ValorCotaHistoricoItem[]> => {
  try {
    const response = await http.get('/rateio/valor-cota/historico');
    return response.data;
  } catch (error) {
    throw new Error(extrairMensagemErro(error, 'Erro ao consultar histórico do rateio por cota'));
  }
};

export const atualizarValorCotaAutomatico = async (): Promise<{
  mensagem: string;
  competencia: string;
  valor: number;
}> => {
  try {
    const response = await http.post('/rateio/valor-cota/atualizar-automatico', {});
    return response.data;
  } catch (error) {
    throw new Error(extrairMensagemErro(error, 'Erro ao buscar o valor atualizado na Hinova'));
  }
};

export const atualizarValorCota = async (
  valor: number,
  competencia?: string
): Promise<{ mensagem: string; competencia: string; valor: number }> => {
  try {
    const response = await http.put(
      '/rateio/valor-cota',
      competencia ? { valor, competencia } : { valor }
    );
    return response.data;
  } catch (error) {
    throw new Error(extrairMensagemErro(error, 'Erro ao atualizar o valor do rateio por cota'));
  }
};
